<template>
  <h1 class="mt-3 mb-3">採購專業人員基礎證照
    <span class="d-none d-md-inline">|</span> <br class="d-md-none"/>
    測驗練習 (115 年 5月 最新版) ✨
  </h1>
  <div> ✏️ {{ roundQues.length }}
    / ✔️ {{ corrects.length }}
    / ❌ {{ wrongs.size }}
    / <span class="fw-bolder">{{ completedImage }} {{ completed }}</span>
  </div>

  <div class="question-block">
    <div v-html="smartQues"></div>

    <div class="question-ref">
      {{ quesObj.category }} | {{quesObj.qno}}
      <span v-if="quesObj.law">
        |
        <a :href="getRefLawLink()" target="_blank">
        {{ quesObj.law }}
        </a>
      </span>
    </div>
  </div>

  <div class="answer-block">
    <ol>
    <li v-for="(a, index) in quesObj.ansPool" :key="a" class="answer-option"
      v-bind:class="{ 'correct-answer': isCorrect(index), 'wrong-answer': isWrong(index)}">
      {{a}}
    </li>
    </ol>
  </div>

  <div class="answer-btns">
    <div v-for="(a,index) in quesObj.ansPool"
      :key="index" v-on:click="checkAns(index)"
      class="btn btn-outline-secondary me-5 answer-btn"
      v-bind:class="{ 'disabled' : clickAns != -1}">
      {{index+1}}
    </div>
  </div>

  <hr/>

  <button v-on:click="getQues" class="btn btn-primary me-5">下一題 (J)</button>
  <div class="btn btn-info text-white me-5"
    v-if="wrongs.has(quesObj.qno)"
    v-on:click="iGotIt()">已學會 (G)</div>

  <!-- <button class="btn btn-danger me-5" type="button" data-bs-toggle="offcanvas"
  data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
    答錯的題目
  </button> -->

  <hr/>
  <div class="d-inline-block me-3">
    <div class="form-check">
      <input class="form-check-input" type="checkbox" v-model="includeTF" id="TFQuesTypeBtn">
      <label class="form-check-label" for="TFQuesTypeBtn">
        包含是非題
      </label>
    </div>
  </div>
  <div class="d-xs-block d-md-inline-block ms-2 me-2 mt-2 mb-2">
    <select class="form-select" aria-label="Default select" v-model="gameTapeSelected" >
      <option v-for="option in gameTapeOptions" v-bind:value="option.value" :key="option.value">
        {{ option.text }}
      </option>
    </select>
  </div>
  <!-- <div class="btn btn-success me-3 ms-3 mb-2 d-md-inline-block d-block"
    v-on:click="loadRandomQues(30)">載入隨機題庫 (R)</div> -->
  <div class="btn btn-success me-3 ms-3 mb-2 d-md-inline-block d-block"
    v-on:click="loadAllQues()">載入題目 (A)</div>
  <div class="btn btn-danger me-3 ms-3 mb-2 d-md-inline-block d-block"
    v-on:click="loadErrorQues()">錯題再練 (F)</div>
  <div class="btn btn-outline-danger me-3 ms-3 mb-2 d-md-inline-block d-block"
    v-on:click="updateSystem()">更新題庫</div>
  <a href="https://sdwh.dev/about/" target="_blank" class="btn btn-outline-primary me-3 ms-3 mb-2 d-md-inline-block d-block">關於作者</a>
  <offcanvas :wrongs="wrongs"/>

</template>

<script>
// @ is an alias to /src
import _ from 'lodash';
import quesbank from '@/data/quesbank.json';
import Chance from 'chance';
import offcanvas from '@/components/OffCanvas.vue';

const chanceInstance = new Chance();

function randomQues(absoluteQno, newQues, gameTape = 'MC0', includeTF = true) {
  if (newQues === false && absoluteQno !== null && absoluteQno !== null) {
    return quesbank[absoluteQno];
  }

  const excludeQuesType = includeTF === false ? '是非題' : '';

  const filterQuesBank = Object.values(quesbank).filter(
    (e) => e.category === gameTape && e.quesType !== excludeQuesType,
  );
  const randomQno = chanceInstance.integer({ min: 0, max: filterQuesBank.length - 1 });
  return filterQuesBank[randomQno];
}

function smartString(quesString) {
  const regexp = /採購法第(\d{1,3})條/i;
  const match = quesString.match(regexp);

  if (match !== null) {
    const [keywords, lawNo] = match;

    const href = `https://law.moj.gov.tw/LawClass/LawSingle.aspx?pcode=A0030057&flno=${lawNo}`;
    const replaced = `<a href='${href}' target='_blank'>${keywords}</a>`;

    return quesString.replace(keywords, replaced);
  }
  return quesString;
}

function updateStorage(corrects, wrongs, completed, gameTapeSelected, roundQues) {
  const roundQuesNumber = roundQues.map((q) => q.qno);
  localStorage.appSavings = JSON.stringify({
    corrects,
    wrongs: Array.from(wrongs),
    completed,
    gameTapeSelected,
    roundQuesNumber,
  });
}

export default {
  name: 'Home',
  data() {
    return {
      showAns: false,
      showOffCanvas: false,
      clickAns: -1,
      absoluteQno: this.$route.params.id,
      quesObj: null,
      roundQues: [],
      roundFinish: [],
      corrects: [],
      wrongs: new Set(),
      documents: [],
      includeTF: false,
      completed: 0,
      gameTapeSelected: '政府採購法之履約管理及驗收',
      gameTapeOptions: [
        { text: '政府採購法之履約管理及驗收', value: '政府採購法之履約管理及驗收' },
        { text: '採購契約', value: '採購契約' },
        { text: '投標須知及招標文件製作', value: '投標須知及招標文件製作' },
        { text: '政府採購全生命週期概論', value: '政府採購全生命週期概論' },
        { text: '政府採購法之罰則及附則', value: '政府採購法之罰則及附則' },
        { text: '道德規範及違法處置', value: '道德規範及違法處置' },
        { text: '電子採購實務', value: '電子採購實務' },
        { text: '政府採購法之爭議處理', value: '政府採購法之爭議處理' },
        { text: '最有利標及評選優勝廠商', value: '最有利標及評選優勝廠商' },
        { text: '工程及技術服務採購作業', value: '工程及技術服務採購作業' },
        { text: '政府採購法之總則、招標及決標', value: '政府採購法之總則、招標及決標' },
        { text: '底價及價格分析', value: '底價及價格分析' },
        { text: '財物及勞務採購作業', value: '財物及勞務採購作業' },
        { text: '錯誤採購態樣', value: '錯誤採購態樣' },
      ],
    };
  },
  components: {
    offcanvas,
  },
  beforeMount() {
    if (localStorage.appSavings !== undefined) {
      const appSavings = JSON.parse(localStorage.appSavings);

      (
        {
          corrects: this.corrects,
          completed: this.completed,
          gameTapeSelected: this.gameTapeSelected,
        } = appSavings
      );

      this.wrongs = new Set(appSavings.wrongs);
      this.roundQues = [];
      appSavings.roundQuesNumber.forEach((qno) => this.roundQues.push(quesbank[qno]));

      if (this.roundQues.length === 0) {
        this.loadAllQues();
      } else {
        this.getQues();
      }
    } else {
      this.loadAllQues();
    }
  },
  mounted() {
    window.addEventListener('keypress', (e) => {
      const inputKey = e.key.toString();
      // console.log(inputKey);
      if (inputKey === '1' || inputKey === '2' || inputKey === '3' || inputKey === '4') {
        if (this.clickAns === -1) {
          this.checkAns(parseInt(inputKey, 10) - 1);
        }
      }
      if (inputKey === 'Enter' || inputKey === 'j' || inputKey === 'J') {
        this.getQues();
      }
      if (inputKey === 'r' || inputKey === 'R') {
        this.loadRandomQues(30);
      }
      if (inputKey === 'a' || inputKey === 'A') {
        this.loadAllQues();
      }
      if (inputKey === 'f' || inputKey === 'F') {
        this.loadErrorQues();
      }
      if (inputKey === 'g' || inputKey === 'G') {
        this.iGotIt();
      }
    });
  },
  watch: {
    $route(to) {
      // console.log(to.params.id);
      this.setQuestion(randomQues(to.params.id, false));
    },
  },
  computed: {
    completedImage() {
      if (this.completed < 10) {
        return '🐸 採購入伍生';
      }
      if (this.completed < 90) {
        return '─ 採購少尉';
      }
      if (this.completed < 180) {
        return '═ 採購中尉';
      }
      if (this.completed < 450) {
        return '≡ 採購上尉';
      }
      if (this.completed < 900) {
        return '🏵️ 採購少校';
      }
      if (this.completed < 1800) {
        return '🏵️🏵️ 採購中校';
      }
      if (this.completed < 3600) {
        return '🏵️🏵️🏵️ 採購上校';
      }
      if (this.completed < 6000) {
        return '⭐ 採購少將';
      }
      if (this.completed < 9000) {
        return '⭐⭐ 採購中將';
      }
      if (this.completed < 12000) {
        return '⭐⭐⭐ 採購二級上將';
      }
      return '⭐⭐⭐⭐ 採購一級上將';
    },
    smartQues() {
      return smartString(this.quesObj.question);
    },
  },
  methods: {
    setQuestion(question) {
      const answersWithIndexes = question.ansPool.map(
        (answer, index) => ({ answer, index }),
      );
      const isCatchAllAnswer = ({ answer }) => ['以上皆是', '以上皆非'].includes(answer);
      const trailingAnswers = answersWithIndexes.filter(isCatchAllAnswer);
      const regularAnswers = answersWithIndexes.filter((answer) => !isCatchAllAnswer(answer));
      const shuffledAnswers = _.shuffle(regularAnswers).concat(trailingAnswers);

      this.quesObj = {
        ...question,
        ansPool: shuffledAnswers.map(({ answer }) => answer),
        ansIndex: shuffledAnswers.findIndex(({ index }) => index === question.ansIndex),
      };
    },
    getQues() {
      const randomNumber = chanceInstance.integer({ min: 0, max: this.roundQues.length - 1 });
      this.setQuestion(this.roundQues[randomNumber]);
      this.showAns = false;
      this.clickAns = -1;
    },
    getRefLawLink() {
      const matchNumber = this.quesObj.law.match(/\d+/g);
      if (matchNumber !== null) {
        return `https://law.moj.gov.tw/LawClass/LawSingle.aspx?pcode=A0030057&flno=${matchNumber[0]}`;
      }
      return 'https://law.moj.gov.tw/LawClass/LawAll.aspx?pcode=A0030057';
    },
    checkAns(i) {
      // eslint-disable-next-line no-alert
      const isCorrect = i === this.quesObj.ansIndex;

      if (isCorrect) {
        this.corrects.push(this.quesObj.qno);
      } else {
        this.wrongs.add(this.quesObj.qno);
      }
      this.clickAns = i;
      this.showAns = true;
      _.remove(this.roundQues, (o) => o.qno === this.quesObj.qno);
      this.roundFinish.unshift(this.quesObj.qno);
      this.completed += 1;

      updateStorage(this.corrects,
        this.wrongs,
        this.completed,
        this.gameTapeSelected,
        this.roundQues);
    },
    isCorrect(index) {
      return index === this.quesObj.ansIndex && this.showAns === true;
    },
    isWrong(index) {
      return index !== this.quesObj.ansIndex && this.showAns === true && index === this.clickAns;
    },
    loadRandomQues(quesNumber) {
      this.roundQues = [];
      this.roundFinish = [];

      const qnoSet = [];
      let randomCount = 0;
      while (this.roundQues.length < quesNumber) {
        const getQ = randomQues(null, true, this.gameTapeSelected, this.includeTF);
        if (qnoSet.includes(getQ.qno) === false) {
          this.roundQues.push(getQ);
          qnoSet.push(getQ.qno);
        }

        if (randomCount === 999) {
          break;
        }
        randomCount += 1;
      }
      this.getQues();
    },
    loadAllQues() {
      this.roundQues = [];
      this.roundFinish = [];
      const excludeQuesType = this.includeTF === false ? '是非題' : '';

      const filterQuesBank = Object.values(quesbank).filter(
        (e) => e.category === this.gameTapeSelected && e.quesType !== excludeQuesType,
      );
      this.roundQues = filterQuesBank;
      this.getQues();
    },
    loadErrorQues() {
      this.roundQues = [];
      this.roundFinish = [];

      Array.from(this.wrongs).forEach((qno) => {
        this.roundQues.push(quesbank[qno]);
      });

      this.getQues();
    },
    updateSystem() {
      localStorage.removeItem('appSavings');
      this.corrects = [];
      this.wrongs = new Set();
      this.loadAllQues();
    },
    iGotIt() {
      this.wrongs.delete(this.quesObj.qno);
      this.getQues();
    },
  },
};
</script>

<style scoped lang="scss">
$block-width : 62%;
$desktop: 'min-width: 1024px';
$pad: 'max-width: 1024px';
$mobile: 'max-width: 600px';

@mixin desktop{
  @media($desktop){
    @content;
  }
}
@mixin pad{
  @media($pad){
    @content;
  }
}
@mixin mobile{
  @media($mobile){
    @content;
  }
}

.correct-answer{
  color: green;
  font-weight: 900;
}

.wrong-answer{
  color: red;
  text-decoration: line-through;
}

.question-block{
  border: 2px solid teal;
  color: teal;
  border-radius: 3px;
  width: $block-width;
  display: block;
  margin: 20px auto;
  padding: 15px 15px;
  text-align: justify;
  font-size: 1.5rem;
  letter-spacing: 1px;
  @include pad{
    width: 95%;
  }
  @include mobile{
    width: 95%;
    font-size: 1rem;
  }
}

.answer-block{
  background-color: beige;
  border: 2px darksalmon dashed;
  color: black;
  padding: 5px;
  font-size: 1.5rem;
  width: $block-width;
  text-align: left;
  display: inline-block;
  margin-bottom: 10px;
  border-radius: 3px;
  @include pad{
    width: 95%;
  }
  @include mobile{
    width: 95%;
    font-size: 1rem;
  }
}

.answer-btns{
  margin-top: 20px;
  @include mobile{
    margin-top: 5px;
  }
}

.answer-btn{
  font-size: 1.25rem;
  padding: .5rem 1rem;
  @include mobile{
    margin-right: 25px !important;
    margin-left: 25px !important;
    font-size: 1rem;
    padding: .5rem 1rem;
  }
}

.question-ref{
  font-size: 1.25rem;
  color: black;
  text-align: right;

  @include mobile{
    font-size: 0.8rem;
  }
}

</style>
